import { isUncPath, isWindowsDrivePath } from "@t3tools/shared/path";
function isRootPath(value) {
    return value === "/" || value === "\\" || /^[a-zA-Z]:[/\\]?$/.test(value);
}
function getAbsolutePathKind(value) {
    if (isWindowsDrivePath(value) || isUncPath(value)) {
        return "windows";
    }
    if (value.startsWith("/")) {
        return "unix";
    }
    return null;
}
function trimTrailingPathSeparators(value) {
    if (value.length === 0 || isRootPath(value)) {
        return value;
    }
    const trimmed = getAbsolutePathKind(value) === "unix"
        ? value.replace(/\/+$/g, "")
        : value.replace(/[\\/]+$/g, "");
    if (trimmed.length === 0) {
        return value;
    }
    return /^[a-zA-Z]:$/.test(trimmed) ? `${trimmed}\\` : trimmed;
}
function splitPathSegments(value, separator) {
    return value.split(separator === "/" ? /\/+/ : /[\\/]+/).filter(Boolean);
}
function splitAbsolutePath(value) {
    if (isWindowsDrivePath(value)) {
        const root = `${value.slice(0, 2)}\\`;
        const segments = splitPathSegments(value.slice(root.length), "\\");
        return { root, separator: "\\", segments };
    }
    if (isUncPath(value)) {
        const segments = splitPathSegments(value, "\\");
        const [server, share, ...rest] = segments;
        if (!server || !share)
            return null;
        return {
            root: `\\\\${server}\\${share}\\`,
            separator: "\\",
            segments: rest,
        };
    }
    if (value.startsWith("/")) {
        return {
            root: "/",
            separator: "/",
            segments: splitPathSegments(value.slice(1), "/"),
        };
    }
    return null;
}
export function normalizeProjectPathForDispatch(value) {
    return trimTrailingPathSeparators(value.trim());
}
export function normalizeProjectPathForComparison(value) {
    const normalized = normalizeProjectPathForDispatch(value);
    if (isWindowsDrivePath(normalized) || normalized.startsWith("\\\\")) {
        return normalized.replaceAll("/", "\\").toLowerCase();
    }
    return normalized;
}
export function findProjectByPath(projects, candidatePath) {
    const normalizedCandidate = normalizeProjectPathForComparison(candidatePath);
    if (normalizedCandidate.length === 0) {
        return undefined;
    }
    return projects.find((project) => {
        const cwd = project.workspaceRoot ?? project.cwd;
        return cwd ? normalizeProjectPathForComparison(cwd) === normalizedCandidate : false;
    });
}
export function inferProjectTitleFromPath(value) {
    const normalized = normalizeProjectPathForDispatch(value);
    const absolutePath = splitAbsolutePath(normalized);
    if (absolutePath) {
        return absolutePath.segments.findLast(Boolean) ?? normalized;
    }
    const segments = normalized.split(/[/\\]/);
    return segments.findLast(Boolean) ?? normalized;
}
